import React from 'react';

/**
 * Full-bleed Hero-Hintergrundbild, zwei Anzeige-Modi:
 * - 'cover' (Standard): füllt die ganze Fläche, schneidet Überstand ab —
 *   passt für Umgebungsfotos, bei denen ein abgeschnittener Rand nicht
 *   auffällt.
 * - 'contain': schneidet NIE etwas ab — Pflicht für Bilder mit fixem
 *   Ecken-Inhalt (z.B. Logos). Das ganze Bild bleibt sichtbar, mittig,
 *   proportional (nie verzerrt); der Rand wird mit einer unscharfen Kopie
 *   desselben Bildes gefüllt statt leerem Balken.
 */
export const HeroBackground = ({ src, fit = 'cover', posX = 50, posY = 50, className = '' }) => {
  if (!src) return null;

  if (fit === 'contain') {
    return (
      <div className={`absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
        <div
          className="absolute inset-0 bg-cover bg-center scale-110"
          style={{ backgroundImage: `url(${src})`, filter: 'blur(48px) brightness(0.5)' }}
        />
        <img src={src} alt="" className="absolute inset-0 w-full h-full object-contain" />
      </div>
    );
  }

  return (
    <div
      className={`absolute inset-0 bg-no-repeat bg-cover ${className}`}
      style={{ backgroundImage: `url(${src})`, backgroundPosition: `${posX}% ${posY}%` }}
      aria-hidden="true"
    />
  );
};

export default HeroBackground;
